// 게임 규칙 상수. (jobs.json 의 rules 와 같은 값 — 바꿀 때는 양쪽을 맞춘다)
export const GROUPS = ['비겁', '식상', '재성', '관성', '인성'];
export const GROUP_LABEL = { 비겁: '관계', 식상: '활동', 재성: '재물', 관성: '직업', 인성: '학업' };
export const FOCUS_LABEL = { 비겁: '관계', 식상: '활동', 재성: '재물', 관성: '직업', 인성: '학업' };

// 오행 → 기질
export const EL_TRAIT = { 목: '배려', 화: '열정', 토: '안정', 금: '원칙', 수: '신중' };
export const TRAIT_EL = { 배려: '목', 열정: '화', 안정: '토', 원칙: '금', 신중: '수' };

export const JOB_RULES = {
  levels: {
    2: { main: 30, sub: 15, minAge: 24 },
    3: { main: 45, sub: 25, minAge: 32 },
    4: { main: 60, sub: 35, minAge: 42 },
  },
  firstJobAge: 24,
  retireAge: 60,
  eventStartAge: 15,
};

export const STAT_MIN = 5;
export const STAT_MAX = 100;
// 고서의 수치가 아닌 게임 성장 규칙. 초기 원국 판정과 별도로 조정한다.
export const ENGINE_RULES_VERSION = 6;
export const BALANCE_RULES = {
  version: ENGINE_RULES_VERSION,
  focusGain: 2,
  growthFloor: 0.2,
  luckShare: 1 / 3, // 옛 저장(luckModel 없음)에만 쓴다. 새 생은 운으로 스탯이 더해지지 않는다.
  defaultEventCooldownYears: 5,
  natalEventMin: 0.85,
  natalEventMax: 1.15,
  relationshipMin: 0.75,
  relationshipRange: 0.5,
};
// 기회: 세운 천간 10 / 세운 지지 5 / 대운 천간 5 / 대운 지지 3, 8 이상이면 '열린 기회'
export const OPEN_THRESHOLD = 8;

// 자동 결정에서 한난조습이 선택 점수에 주는 최대 기울기. 기질 점수(오행 %)와 같은 단위이며 0이면 반영하지 않는다.
// 이벤트 선정·능력치 계산에는 쓰지 않는다. 한난조습에서 성격을 풀이하는 고서 근거는 없고 게임 해석이다.
export const AUTO_CLIMATE_WEIGHT = 15;

// 자동 결정: 기질(오행 비율)이 먼저, 능력치는 보조, 난수는 동점 깨기. (게임 해석이며 고서 규칙이 아니다)
// 집중 분야와 기질의 연결: 배려→관계, 열정→활동, 안정→재물, 원칙→직업, 신중→학업.
export const GROUP_TRAIT = { 비겁: '배려', 식상: '열정', 재성: '안정', 관성: '원칙', 인성: '신중' };
export const AUTO_RULES = Object.freeze({
  fitAssist: 3,                                      // 직업·전직을 고를 때 방향 어울림(0~3) 한 점당 가점(기질 % 단위). 새 규칙(luckModel)에서만 쓴다
  statAssist: 0.2,                                   // 직업·집중 분야를 고를 때 능력치 반영 비중(기질 % 대비)
  choiceNoise: 2,                                    // 선택지 점수의 난수 폭(동점 깨기용)
  // 이벤트 선택지 점수 보정(게임 해석, 고서 근거 없음). 400개 원국 시뮬레이션으로 정한 값이다.
  declineBase: 12,                                   // 거절·대안 선택지는 오행 비율 대신 이 값에서 시작한다(토·수가 많은 원국에서 거절이 항상 이기는 문제)
  actFloor: 12,                                      // 행동 선택지 기질 점수의 하한(해당 오행이 0%여도 행동할 수 있게)
  natalStrength: 2,                                  // 행동 선택지에 더하는 가산: 이벤트 분야의 원국 능력치 - 5개 분야 평균 (한 점당)
  relation: { same: 0.5, sheng: 1, ke: -1 },        // 사람 만남: 내 기질 오행과 상대 오행의 관계 가점
});
